<template>
    <section class="main-content pb-5">
        <div class="container-fluid">

            <div class="ibox float-e-margins">
                <div class="ibox-title">
                    <h5 style="font-family: 'Kanit', sans-serif; font-size: 16px;"><b>ข้อมูลข่าวสาร</b></h5>
                </div>
                <div class="ibox-content">
                    <div class="form-group has-feedback">
                        <h1><font color="black"> สวัสดีค่ะ ทีมงาน {{site_name}} ยินดีต้อนรับทุกท่าน </font></h1>
                        <div class="ibox-content no-padding">   
                            <ul class="list-group">
                                <li class="list-group-item">
                                    <br>
                                    <h2><span class="badge text-info-head text-center">ประกาศถึงสมาชิก</span></h2>

                                    <br>
                                    <h2><font color="">เรียน</font> <font color="blue"> สมาชิกทุกยูสเซอร์ </font> </h2>
                                    <h2><font color="">เรื่อง</font> <font color="blue"> การติดต่อขอรับข้อมูล</font></h2>
                                    <br>

                                    <h3><b><font color="">หากท่านสมาชิกมีคำถาม หรือข้อสงสัย และต้องการติดต่อเพื่อขอรับข้อมูล </font></b></h3>
                                    <h3><b><font color="">ทางทีมงาน ขอรบกวนให้ท่านสมาชิก <font color="red">ติดต่อแอดมิน/คอลเซ็นเตอร์ ผ่านทางไลน์เท่านั้น</font> นะคะ</font></b></h3>

                                    <p></p>
                                    <h3><b><font color="">ติดต่อ Call Center (LINE ID) : </font><a :href="line_contact" target="_blank">{{line_name}}</a> </b></h3>
                                    <br>

                                    <h3><font color="blue">**ด้วยความห่วงใย และ ปรารถนาดี จาก ทีมงาน {{site_name}}</font></h3>
                                    <p></p>
                                </li>
                            </ul>   
                        </div>


                        <!-- <div class="ibox-content no-padding">   
                            <ul class="list-group">
                                <li class="list-group-item">
                                    <br>
                                    <h2><font color="blue"> ประกาศถึงสมาชิก เรื่องการถอนเครดิต </font></h2>
                                    <h2><font color="blue">เรียน สมาชิกทุกยูสเซอร์ </font> </h2>
                                    <h2><font color="blue">เรื่อง การถอนเครดิต</font></h2>
                                    <br>

                                    <h3><b><font >เพื่อความรวดเร็วและถูกต้อง ในการแจ้งถอนเครดิตประเภทหวยต่างๆ  ขอความกรุณาท่านสมาชิกทุกท่าน ใส่หมายเหตุ ในช่องการถอน เช่น</font></b></h3>
                                    <h3><b><font >หากท่านถูกรางวัล หวยยี่กี พิมพ์ "ถอนยี่กี"</font></b></h3>
                                    <h3><b><font >หากท่านถูกรางวัล หวยฮานอย พิมพ์ "ถอนฮานอย"</font></b></h3>
                                    <h3><b><font >หากท่านถูกรางวัล หวยรัฐบาล พิมพ์ "ถอนหวยรัฐ" เป็นต้น</font></b></h3>
                                    <br>

                                    <h3><font color="blue">**ด้วยความห่วงใย และ ปรารถนาดี จาก ทีมงาน {{site_name}}</font></h3>
                                    <p></p>
                                </li>
                            </ul>   
                        </div> -->

                    </div>
                </div>
            </div>

        </div>
    </section>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'

export default {
    name: 'helpcenter',
    data () {
        return {
            site_name: '',
            line_contact: '',
            line_name: '',
        }
    },
    methods: {
        async loadLineContact () {
            try {
                const response = await this.$store.dispatch('information/getLineContact')
                this.line_contact = response.link
                this.line_name = response.name

            } catch (error) {
                console.log('error', error)
            }
        },
    },
    computed: {
        ...mapState({
            user: state => state.user.user,
            lineContact: state => state.information.lineContact,
        }),
        lastUpdate () {
            let now = new Date()
            return moment(now).format('DD/MM/YYYY HH:mm:ss')
        },
    },
    created () {
        this.site_name = process.env.VUE_APP_SITE

        if (this.lineContact.link || this.lineContact.name){
            this.line_contact = this.lineContact.link
            this.line_name = this.lineContact.name
        }
        else {
            this.loadLineContact()
        }
    },
    destroyed () {
    }
}

</script>

<style lang="css" scoped>

.text-info-head {
    color: #212529;
    background-color: #ffc107;
    font-size: 18pt;
    font-family: 'Kanit', sans-serif;
}

</style>
